import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
export function Hero() {
  const scrollToServices = () => {
    document.getElementById('services')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <header className="w-full bg-white pt-16 md:pt-20" data-id="element-60">
      <div className="w-full max-w-7xl mx-auto" data-id="element-61">
        <img src="https://cdn.magicpatterns.com/uploads/oQxfLC4cYe1wu4Aw6twW8e/banner.png" alt="VR Beauty Studio — Uñas, Cejas y Pestañas" className="w-full h-auto max-h-[600px] object-cover object-center" data-id="element-62" />
      </div>

      <div className="relative z-10 flex flex-col items-center justify-center px-4 md:px-12 py-16 text-center bg-pink/20" data-id="element-63">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="space-y-4" data-id="element-64">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-charcoal flex items-center justify-center gap-3 flex-wrap" data-id="element-65">
            Uñas, Cejas, Pestañas y Cabello
            <Sparkles className="w-8 h-8 text-gold" data-id="element-66" />
          </h1>

          <p className="text-lg md:text-xl text-charcoal/80 max-w-2xl mx-auto" data-id="element-67">
            Atención profesional y personalizada en Pocitos
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="flex flex-col sm:flex-row gap-4 mt-12" data-id="element-68">
          <a href="https://vrbeautystudio.koob.uy" target="_blank" rel="noopener noreferrer" className="px-8 py-4 bg-gold text-white font-semibold rounded-full hover:bg-gold/90 transition-colors shadow-lg hover:shadow-xl" data-id="element-69">
            Reservá tu turno
          </a>
          <button onClick={scrollToServices} className="px-8 py-4 bg-transparent border-2 border-pink text-charcoal font-semibold rounded-full hover:bg-pink/20 transition-colors" data-id="element-70">
            Ver servicios
          </button>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 0.6
      }} className="mt-16" data-id="element-71">
          <div className="flex items-center justify-center gap-4" data-id="element-72">
            <div className="w-24 h-0.5 bg-gold" data-id="element-73" />
            <div className="w-3 h-3 bg-gold rotate-45" data-id="element-74" />
            <div className="w-24 h-0.5 bg-gold" data-id="element-75" />
          </div>
        </motion.div>
      </div>
    </header>;
}